import SettingsLayout from "@/components/SettingsLayout";
import { csrfToken } from "@/lib/fetchSideEffect";

const inputClass =
  "w-full text-sm bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 border border-gray-200 dark:border-gray-700 rounded-md px-2.5 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500/20";

export default function SettingsLaterKeywords({ laterKeywords = "" }: { laterKeywords?: string }) {
  return (
    <SettingsLayout active="later_keywords" title="Сразу в «Задачи»">
      <section className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg p-4 space-y-3">
        <div>
          <h2 className="text-sm font-medium text-gray-900 dark:text-white">Ключевые слова</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Новая задача без срока и без «Моего дня», название которой начинается с одного из этих слов,
            попадает сразу в «Задачи», минуя «Входящее». По слову в строке или через запятую; регистр не важен.
          </p>
        </div>
        <form method="POST" action="/settings/later_keywords" className="space-y-2">
          <input type="hidden" name="authenticity_token" value={csrfToken()} />
          <input type="hidden" name="_method" value="patch" />
          <textarea
            name="later_keywords"
            aria-label="Ключевые слова"
            defaultValue={laterKeywords}
            maxLength={2000}
            rows={5}
            placeholder={"revolver\nревольвер"}
            className={inputClass}
          />
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md font-medium text-sm"
          >
            Сохранить
          </button>
        </form>
      </section>
    </SettingsLayout>
  );
}
